import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PutOrgUnitAthleteEntryAthleteEntryIndividualRosterEntryData = (orgUnitAthleteEntryId, orgUnitAthleteEntryIndividualRosterEntryArray, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const orgUnitAthleteEntryIdForUrl = orgUnitAthleteEntryId ? encodeURIComponent(orgUnitAthleteEntryId) : 'NaN';
    const url = `/OrgUnitAthleteEntry/${orgUnitAthleteEntryIdForUrl}/AthleteEntry/IndividualRosterEntry`;
    MeetHttpHelper(url, 'PUT', orgUnitAthleteEntryIndividualRosterEntryArray)
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutOrgUnitAthleteEntryAthleteEntryIndividualRosterEntryData;